import { CookieMonster } from 'root/utils/cookies/cookieMonster';
import { LoggingHandler } from 'root/utils/errorReporting/LoggingHandler';

// Emits a Datadog RUM action when the geoConfig cookie was set by the Cloudflare
// Worker (source === 'cf') rather than nginx (server-side GeoIP2, no source field).
// The CF Worker only sets it on edge cache HITs, so this measures how often the
// edge path is the source. Rate vs. total is derived from RUM view counts.
// See agents/agents.nginx.md (Geo Cookie) for the two sources.
export function trackGeoConfigSource(): void {
    const geoConfig = new CookieMonster().getCookie('geoConfig');
    if (geoConfig?.source !== 'cf') return;

    LoggingHandler().logUserAction('geoconfig_set_by_cf', {
        searchTerm: 'geoconfig-source',
        fileName: 'geoConfigSourceTracking.ts',
        tags: ['cookies'],
        additionalData: {
            country_code: geoConfig?.country_code,
            state_code: geoConfig?.state_code,
        },
    });
}
